export enum TipoDeCuentaEnum {
    Corriente = 1,
    Ahorro = 2,
}